const SCOPES = 'identify email bot'; // Add other scopes if needed
const PERMISSIONS = '2065';

const OAUTH_URL = `https://discord.com/oauth2/authorize?client_id=1228787791127904367&permissions=${encodeURIComponent(PERMISSIONS)}&scope=${encodeURIComponent(SCOPES)}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_DISCORD_REDIRECT_URI)}&response_type=code`;

export function handleDiscordLogin() {
    console.log(OAUTH_URL);
    window.location.href = OAUTH_URL;
}